/* =====================================================================
   DERBY - keep the collection header in step with AJAX filtering
   (2026-09-28).

   sections/derby-collection-header.liquid is server-rendered: count,
   size / colour / fit chips and the active-filter pills. The theme's
   Filter drawer, sort and pagination update the product grid by AJAX
   and push a new URL, but never re-render our header, so after a drawer
   filter it kept saying "36 styles" with no pills while the theme's own
   "6 Choices x Relaxed Fit" row was the only thing telling the truth.

   This re-renders the header through the Section Rendering API whenever
   the URL's query changes. While the header is known to be current,
   <html> carries .drby-clp-live and derby-premium.css hides the theme's
   duplicate row. If a refresh fails the class comes off and the theme's
   row shows again, so the shopper always sees one correct summary.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__derbyClpSync) return;
  window.__derbyClpSync = true;

  var root = document.documentElement;

  function headerSection() {
    var head = document.querySelector('.derby-clp-head');
    return head ? head.closest('.shopify-section') : null;
  }

  var sec = headerSection();
  if (!sec || !sec.id) return;
  var sectionId = sec.id.replace(/^shopify-section-/, '');

  // Server-rendered on this load, so it is current.
  root.classList.add('drby-clp-live');

  var lastQuery = location.search;
  var timer = null;
  var seq = 0;

  function refresh() {
    var q = location.search;
    if (q === lastQuery) return;
    lastQuery = q;
    var mine = ++seq;
    // Stale until the fresh copy lands.
    root.classList.remove('drby-clp-live');
    var url = location.pathname + q + (q ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
    fetch(url, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (mine !== seq) return; // a newer change is in flight
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(sec.id) || doc.querySelector('.shopify-section');
        var cur = headerSection();
        if (!fresh || !cur || !fresh.querySelector('.derby-clp-head')) throw new Error('no header');
        cur.innerHTML = fresh.innerHTML;
        root.classList.add('drby-clp-live');
      })
      .catch(function () {
        if (mine === seq) root.classList.remove('drby-clp-live');
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 250);
  }

  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m];
    if (typeof orig !== 'function') return;
    history[m] = function () {
      var ret = orig.apply(this, arguments);
      schedule();
      return ret;
    };
  });
  window.addEventListener('popstate', schedule);
})();
